// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TableCard from "src/components/shared/tables/TableCard/TableCard";
import CustomCheckbox from "src/components/shared/inputs/CustomCheckbox/CustomCheckbox";

// Styles
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// Types
import { ClinicUserType } from "src/services/clinics/types";

type UserCardType = {
  user: ClinicUserType;
  isSelectedForViewing: boolean;
  isSelectedForDeletion: boolean;
  handleCheckboxClick: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    id: string
  ) => void;
};

const UserCard = ({
  user,
  isSelectedForViewing,
  isSelectedForDeletion,
  handleCheckboxClick,
}: UserCardType) => {
  const { t } = useTranslation();

  const theme = useTheme();
  const smallerThanSm = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <TableCard
      key={user.email}
      isSelectedForViewing={isSelectedForViewing}
      isSelectedForDeletion={isSelectedForDeletion}
      onClick={() => {}}
      hasHoverState={false}
    >
      <Grid container display="flex" alignItems="center">
        <Grid item xs={1}>
          <CustomCheckbox
            id={`user-checkbox-${user.email}`}
            checkedFill={
              isSelectedForViewing || isSelectedForDeletion
                ? "white"
                : "#202338"
            }
            checkedStroke={
              isSelectedForViewing || isSelectedForDeletion
                ? "#202338"
                : "white"
            }
            checked={isSelectedForDeletion}
            onClick={(
              event: React.MouseEvent<HTMLButtonElement, MouseEvent>
            ) => {
              event.stopPropagation();
              handleCheckboxClick(event, user.email);
            }}
          />
        </Grid>
        <Grid container item xs={11} display="flex" alignItems="center">
          <Grid item xs={12}>
            <Typography
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
              sx={{
                fontSize: { xs: "14px", sm: "16px" },
                paddingRight: "16px",
              }}
            >
              {smallerThanSm && (
                <span style={{ fontWeight: 600 }}>{t("Email")}: </span>
              )}
              {user.email}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </TableCard>
  );
};

export default UserCard;
